import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../../contexts/AuthContext";
import axios from "axios";
import showNotification from "../../../utils/showNotification";
import { ERROR_HANDLER } from "../../../utils/error-handler";
import { createColumnHelper } from "@tanstack/react-table";
import { isBase64 } from "../../../utils/isBase64";
import useS3 from "../../useS3";
import { RRSS_DEFAULT } from "../../../utils/rrss-users";




export default function useModerationStaff() {
    const { authToken } = useContext(AuthContext);
    const { uploadToS3 } = useS3()
    const [isLoading, setIsLoading] = useState(false)
    const [displayForm, setDisplayForm] = useState(null);
    const [initialValuesEdit, setInitialValuesEdit] = useState(null);
    const [users, setUsers] = useState(null)
    const [hasToRender, setHasToRender] = useState(false)


const putTeacher = async (values, config) => {
    const { profilePicture, name, lastname, signature, _id, ...restOfValues } = values
    let profilePictureURL = profilePicture
    let signatureURL = signature

    if (isBase64(profilePicture)) {
        profilePictureURL = await uploadToS3({
            image: profilePicture,
            fileDirectory: `public/images/users`,
            fileName: `${name}-${lastname}-profilePicture`,
            isRequired: false
        })
    }

    if (isBase64(signature)) {
        signatureURL = await uploadToS3({
            image: signature,
            fileDirectory: `public/images/users`,
            fileName: `${name}-${lastname}-signature`,
            isRequired: false
        })
    }

    const jsonData = {
        user_id: _id,
        values: {
            ...restOfValues,
            profilePicture: profilePictureURL,
            signature: signatureURL
        }
    }
    return axios.put(
        `${process.env.REACT_APP_BACKEND_SERVER}admin/moderation/putStaff`,
        jsonData,
        config
    );
}

    const axiosConfig = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + authToken,
        }
    }

    useEffect(() => {
        const getUsers = async () => {
            try {
                setIsLoading(true)
                const urlStaff = `${process.env.REACT_APP_BACKEND_SERVER}admin/moderation/getStaff`
                const { data } = await axios.get(urlStaff, axiosConfig)
                setUsers(data)
            } catch (error) {
                showNotification({
                    color: "red",
                    status: "error",
                    title: "Error al cargar los usuarios.",
                    message: `Detalle: ${ERROR_HANDLER[error.request?.status] || ERROR_HANDLER.defaultError}`,
                    autoClose: 12000
                });
            } finally {
                setIsLoading(false)
            }
        }
        getUsers()
    }, [authToken, hasToRender]);

    const columnHelper = createColumnHelper();
    const columns = [
        columnHelper.accessor("name", {
            cell: (info) => {
                const name = `${info.row.original.name} ${info.row.original.lastname}`;
                return (
                    <span
                        className="salesPayment-studentData-span">
                        {name}
                    </span>
                );
            },
            header: "Nombre",
            size: 200,
            filter: "text",
            enableSorting: false,
            enableColumnFilter: true,
            filterFn: (row, id, filterValue) => {
                if (!filterValue) return true;
                return row.original.name.toLowerCase().includes(filterValue.toLowerCase()) ||
                    row.original.lastname.toLowerCase().includes(filterValue.toLowerCase());
            }
        }),
        columnHelper.accessor('email', {
            cell: info => info.getValue(),
            header: 'Email',
            enableColumnFilter: true,
            enableSorting: false,
            filter: "text",
            filterFn: "includesString",
        }),
        columnHelper.accessor('phone', {
            cell: info => info.getValue(),
            header: 'Teléfono',
            enableColumnFilter: true,
            enableSorting: false,
            size: 104
        }),
        columnHelper.accessor('dni', {
            cell: info => info.getValue(),
            header: 'DNI',
            enableColumnFilter: true,
            enableSorting: false,
            filterFn: "includesString",
            size: 104
        }),
        columnHelper.accessor('academicUnits', {
            cell: info => {
                return info.getValue()?.map(item => (
                    item.comercialInformation.name
                )).join(', ')
            },
            header: 'Unidades Académicas',
            enableColumnFilter: true,
            enableSorting: false,
            filter: "text",
            filterFn: (row, id, filterValue) => {
                if (!filterValue) return true;
                return row.original.academicUnits
                    .map(item => item.comercialInformation.name.toLowerCase())
                    .join(', ').includes(filterValue.toLowerCase());
            },
            size: 240
        }),
    ];

    async function handleSubmit(values) {
        try {
            setIsLoading(true)
            if (!values) return null

            await putTeacher(values, axiosConfig)

            showNotification({
                color: "green",
                status: "success",
                title: "Operación realizada con éxito.",
                message: `Detalle: El usuario ha sido modificado correctamente.`,
            });

            setDisplayForm(null)
            setInitialValuesEdit(null)
            setHasToRender(!hasToRender)
        } catch (error) {
            console.error(error)
            showNotification({
                color: "red",
                status: "error",
                title: "Error al intentar actalizar el usuario.",
                message: `Detalle: ${ERROR_HANDLER[error.request?.status] || ERROR_HANDLER.defaultError}`,
                autoClose: 12000
            });
        } finally {
            setIsLoading(false)
        }
    }

    const editFunc = (rowData) => {
        if (rowData) {
            setInitialValuesEdit({
                ...rowData,
                about: {
                    ...rowData.about,
                    rrss: {
                        ...RRSS_DEFAULT,
                        ...rowData.about?.rrss
                    }
                }
            });
            setDisplayForm(rowData.type);
        }
    };

    // no require
    const formValidation = {}

    return {
        data: users,
        columns,
        isLoading,
        displayForm,
        setDisplayForm,
        initialValuesEdit,
        setInitialValuesEdit,
        handleSubmit,
        editFunc,
        formValidation,
    }
}
